import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableFooter,
  TableHead,
  TableHeader,
  TableRow,
} from "src/@/components/ui/table"

import {
  Stack
} from '@mui/material';
import { useRef, useState } from "react";
import Iconify from "src/components/Iconify";
import { fDate } from "src/utils/formatTime";

import { Button } from "src/@/components/ui/button";
import { DeletePopover } from "src/@/components/shared/DeletePopover";




export default function TableReasons({ data, onEdit, onDelete, onConfirm }) {
  const [openDelete, setOpenDelete] = useState(false);

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead >Nome</TableHead>
          <TableHead className="w-[100px]"></TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {data.map((row, index) => (
          <TableRow key={index}>
            <TableCell className="font-medium">{row.name}</TableCell>
            <TableCell>
              <div className="flex gap-2">
                <Button onClick={() => onEdit(row)} variant="outline" size="icon" >
                  <Iconify icon={"ph:pencil-line"} />
                </Button>
                <Button onClick={() => onDelete(row)} variant="outline" size="icon" >
                  <Iconify color="red" icon={"material-symbols-light:delete-outline"} />
                </Button>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
